export const CONTACT_PERSONS = {
  GET_CONTACT_PERSONS: 'GET_CONTACT_PERSONS',
  UPDATE_CONTACT_PERSON: 'UPDATE_CONTACT_PERSON'
}
